module.exports = __webpack_public_path__ + "img/empty-cart.06d05ac2.svg";